export default resolveSupportedDrmType;

// info about drm https://drmtoday.com/platforms/ table 'HTML5 Browsers'
function resolveSupportedDrmType(userAgent) {
  const { device = {}, browser = {}, os = {} } = userAgent;
  const browserVersion = parseFloat(browser.version);

  let supportedDrmType = '';

  // info about drm https://drmtoday.com/platforms/ table 'HTML5 Browsers'
  if (browser.name === 'Edge') {
    supportedDrmType = 'playready';
  } else if (browser.name === 'IE' && browserVersion >= 11) {
    supportedDrmType = 'playready';
  } else if (browser.name === 'Safari' && browserVersion >= 8) {
    supportedDrmType = 'fairplay';
  } else if (browser.name === 'Chrome' && browserVersion >= 35) {
    supportedDrmType = 'modular';
  } else if (browser.name === 'Firefox' && browserVersion >= 47 && os.name !== 'Linux') {
    supportedDrmType = 'modular';
  } else if (browser.name === 'Opera' && browserVersion >= 31) {
    supportedDrmType = 'modular';
  } else {
    supportedDrmType = 'modular'; // Yandex, Vivaldi, ...etc
  }

  if (device.type === 'mobile' || device.type === 'tablet') {
    if (device.vendor === 'Apple') {
      supportedDrmType = 'fairplay';
    } else {
      supportedDrmType = 'modular';
    }
  }

  return supportedDrmType;
}
